<template>
  <transition name="fade">
    <a v-show="isVisible" href="#app" class="c-pageTop" data-scroll></a>
  </transition>
</template>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: 
      opacity 0.6s linear,
      transform 1s ease-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
</style>

<script>
  /**
   * Modules
   */
  import SweetScroll from 'sweet-scroll'

  /**
   * Share Partial
   */

  export default {
    name: 'cominca-pagetop',
    props: {
      isVisible: {
        type: Boolean,
        required: true,
        default: false,
      }
    },
    computed: {
    },
    mounted() {
      // eslint-disable-next-line no-new
      new SweetScroll({
        easing: 'easeOutCirc'
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/cominca-pagetop.vue